@if (userInfo(); as userInfo) {
  <div ngbDropdown>
    <app-user-icon
      ngbDropdownToggle
      [initials]="userInfo.initials"
      [color]="userInfo.color"
      tabindex="0"
    ></app-user-icon>
    <div ngbDropdownMenu class="dropdown-menu-end row mx-auto align-items-center">
      <div class="fw-bold">{{ userInfo.displayName }}</div>
      <div class="text-muted">{{ userInfo.mail }}</div>
      <div class="text-muted">
        {{ userInfo.currentOrganization?.name ?? 'Geen organisatie' }}
      </div>
      <a class="clickable btn btn-link w-100 border-top text-decoration-none" [routerLink]="['/profiel']"> Profiel </a>
      <button
        type="button"
        class="clickable btn btn-link w-100 border-top text-decoration-none"
        [attr.aria-label]="themeService.isDarkMode() ? 'Lichte modus' : 'Donkere modus'"
        (click)="themeService.toggle()"
      >
        <i
          class="bi me-2"
          [class.bi-sun]="themeService.isDarkMode()"
          [class.bi-moon]="!themeService.isDarkMode()"
          aria-hidden="true"
        ></i>
        {{ themeService.isDarkMode() ? 'Lichte modus' : 'Donkere modus' }}
      </button>
      @if (userInfo.isLocalAccount) {
        <div
          (click)="resetMyPassword()"
          (keypress)="resetMyPassword()"
          tabindex="0"
          class="clickable btn btn-link w-100 border-top text-decoration-none"
        >
          @if (resettingPassword()) {
            <app-spinner></app-spinner>
          }
          Wachtwoord reset
        </div>
      }
      <a class="clickable btn btn-link w-100 border-top text-decoration-none" [routerLink]="['/logout']"> Uitloggen </a>
    </div>
  </div>
}
